import { MessageCircle, Layers, Wrench, Droplet } from "lucide-react";
import { useI18n } from "../i18n/I18nContext";
import { Reveal } from "../hooks/useScrollReveal";

const ICONS = [MessageCircle, Layers, Wrench, Droplet];
// Slight vertical offset per step for the "organic" 2x2
const OFFSETS = ["md:mt-0", "md:mt-16", "md:mt-0", "md:mt-16"];

export default function Process() {
  const { t } = useI18n();
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-[#f9f8f5] py-24 md:py-40"
    >
      <div className="max-w-[1280px] mx-auto px-6 md:px-10">
        <Reveal>
          <div className="eyebrow mb-6" data-testid="process-eyebrow">{t.process.eyebrow}</div>
          <h2
            data-testid="process-title"
            className="font-serif-hero text-[#252525] text-[34px] sm:text-[44px] md:text-[54px] leading-[1.08] max-w-[760px]"
          >
            {t.process.title}
          </h2>
        </Reveal>

        <div className="mt-16 md:mt-24 grid md:grid-cols-2 gap-x-16 lg:gap-x-24 gap-y-16 md:gap-y-24">
          {t.process.steps.map((step, i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={step.n} className={`relative ${OFFSETS[i]}`}>
                <div
                  data-testid={`process-step-${step.n}`}
                  className="relative pl-4 md:pl-8"
                >
                  <div
                    aria-hidden="true"
                    className="absolute -top-14 md:-top-24 -left-2 md:-left-4 font-serif-hero text-[#eeeae1] leading-none select-none pointer-events-none"
                    style={{ fontSize: "clamp(140px, 20vw, 240px)" }}
                  >
                    {step.n}
                  </div>
                  <div className="relative z-10 pt-6 md:pt-12">
                    <div className="flex items-start gap-6">
                      <div className="shrink-0 mt-1">
                        <Icon size={46} strokeWidth={1.15} className="text-[#b86a55]" />
                      </div>
                      <div className="flex-1">
                        <h3 className="text-[#252525] text-[20px] md:text-[22px] font-medium tracking-tight">
                          {step.title}
                        </h3>
                        <p className="mt-3 text-[14.5px] leading-[1.75] text-[#4a4a45] max-w-[440px]">
                          {step.text}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
}
